import React from 'react';
import { Container, Paper, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const ErrorPage = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ px: { xs: 2, sm: 3 } }}>
      <Box sx={{ mt: { xs: 2, sm: 4 }, mb: { xs: 2, sm: 4 } }}>
        <Paper elevation={3} sx={{ p: { xs: 2, sm: 3, md: 4 }, textAlign: 'center' }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
            <img 
              src="/logo.jpeg" 
              alt="FCO Coaching" 
              style={{ 
                maxWidth: '200px', 
                width: '100%', 
                height: 'auto',
                borderRadius: '8px'
              }} 
            />
          </Box>
          
          <ErrorOutlineIcon sx={{ fontSize: { xs: 60, sm: 80 }, color: 'error.main', mb: 2 }} />
          
          <Typography variant="h4" component="h1" gutterBottom color="error.main" sx={{ fontWeight: 'bold', fontSize: { xs: '1.5rem', sm: '2rem', md: '2.125rem' } }}>
            Error en el Pago
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ mt: 3, color: 'text.secondary', fontSize: { xs: '0.875rem', sm: '1rem' } }}>
            Ha ocurrido un error al procesar tu pago. Por favor, intenta nuevamente.
          </Typography>
          
          <Typography variant="body2" paragraph sx={{ color: 'text.secondary', fontSize: { xs: '0.875rem', sm: '1rem' } }}>
            Si el problema persiste, contáctanos para ayudarte.
          </Typography>
          
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate('/')}
            sx={{ mt: 2 }}
            size="large"
            fullWidth={{ xs: true, sm: false }}
          >
            Intentar nuevamente
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default ErrorPage;

